import req from './request.js'

export function authLogin(data) {
  return req('post', '/api/user/tiktokCallback', data)
}

export function userLogin(data) {
  return req('post', '/api/user/login', data)
}

export function userRegister(data) {
  return req('post', '/api/user/reg', data)
}